import { render } from "./AccordionContent.vue?vue&type=template&id=ce387a6a"
import script from "./AccordionContent.vue?vue&type=script&lang=js"
export * from "./AccordionContent.vue?vue&type=script&lang=js"
script.render = render

export default script